import React, {useEffect, useRef} from 'react';
import ReactPlayer from 'react-player';

const ReactVideoPlayer: React.FC<{
  video: any;
  isMiniPlayer?: boolean;
  setShowMiniPlayer?: React.Dispatch<any>;
  setModalMiniPlayer?: React.Dispatch<any>;
}> = ({video, isMiniPlayer = false, setShowMiniPlayer, setModalMiniPlayer}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (wrapperRef.current) {
      const videoEl = wrapperRef.current.querySelector(
        'video'
      ) as HTMLVideoElement & {controlsList?: string};
      if (videoEl) {
        videoEl.controlsList = 'nodownload';
        videoEl.oncontextmenu = (e) => {
          e.preventDefault();
        };
        videoEl.disablePictureInPicture = true;
      }
    }
  }, [video?.url]);

  return (
    <div ref={wrapperRef}>
      <ReactPlayer
        src={video?.url}
        slot="media"
        controls
        style={{
          cursor: isMiniPlayer ? 'pointer' : 'auto'
        }}
        muted={isMiniPlayer}
        playing={true}
        className={`${isMiniPlayer ? 'miniPlayer' : 'reactPlayernormal'}`}
        onClick={() => {
          if (setModalMiniPlayer) {
            setModalMiniPlayer(video);
          }
          if (setShowMiniPlayer) {
            setShowMiniPlayer(null);
          }
        }}
      />
    </div>
  );
};

export default ReactVideoPlayer;
